import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { heroSlides } from "../mock";
import { resolveImg } from "../api";

const HeroCarousel = ({ slides }) => {
  const data = slides && slides.length ? slides : heroSlides;
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (idx >= data.length) setIdx(0);
    const t = setInterval(() => setIdx((i) => (i + 1) % data.length), 5000);
    return () => clearInterval(t);
  }, [data.length, idx]);

  const go = (n) => setIdx((n + data.length) % data.length);

  return (
    <section className="relative w-full overflow-hidden bg-[#050304]">
      <div className="relative h-[58vh] min-h-[380px] sm:h-[70vh] lg:h-[82vh]">
        {data.map((slide, i) => (
          <div
            key={slide.id || i}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              i === idx ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <img src={resolveImg(slide.image)} alt={slide.title} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="mx-auto max-w-[1400px] w-full px-6 lg:px-12">
                <div className={`max-w-xl transition-all duration-700 ${i === idx ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
                  <p className="text-[#FFE29A] text-xs sm:text-sm tracking-[0.35em] uppercase mb-4">
                    {slide.eyebrow}
                  </p>
                  <h1 className="font-serif text-4xl sm:text-5xl lg:text-7xl text-[#F3E7D8] leading-tight">
                    {slide.title}
                  </h1>
                  <p className="mt-4 text-[#E8B9C4] text-base sm:text-lg max-w-md">{slide.subtitle}</p>
                  <button
                    onClick={() => navigate(slide.to)}
                    className="mt-8 inline-block bg-gradient-to-br from-[#FFE29A] to-[#C8932F] text-[#050304] px-8 py-3.5 text-sm font-semibold uppercase tracking-widest rounded-sm hover:opacity-90 transition-opacity"
                  >
                    {slide.cta}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Arrows */}
        <button
          onClick={() => go(idx - 1)}
          aria-label="Previous"
          className="absolute left-4 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/30 backdrop-blur text-white flex items-center justify-center hover:bg-black/60 transition-colors"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <button
          onClick={() => go(idx + 1)}
          aria-label="Next"
          className="absolute right-4 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-black/30 backdrop-blur text-white flex items-center justify-center hover:bg-black/60 transition-colors"
        >
          <ChevronRight className="h-5 w-5" />
        </button>

        {/* Dots */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
          {data.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`Slide ${i + 1}`}
              className={`h-2 rounded-full transition-all ${
                i === idx ? "w-8 bg-[#FFE29A]" : "w-2 bg-white/50"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
